const Spinner = () => {
    return (
        <div className="w-10 h-10 mx-auto rounded-full border-4 border-white border-t-rose-700  my-8 animate-spin"></div>
    )
}

export default Spinner
